const RouteNames = {
  ARTICLE: "article",
  AWARDS: "awards",
  CATEGORY_LANDING: "category-landing",
  DESTINATION_ARTICLE: "destination-article",
  DESTINATION_LANDING: "destination-landing",
  HOME: "home",
  BLOG_HOME: "blog-home",
  BLOG_POST: "blog-post",
  BLOG_ARCHIVE: "blog-archive",
  PRODUCTS_DIRECTORY: "products-directory",
  PLAN_LIST: "plan-listing",
  PLAN_REVIEWS_LANDING: "plan-reviews-landing",
  QUOTE_RESULT: "quote-result",
  QUOTE_RESULT_PATHS: {
    VISITOR: "/visitor-health-insurance/quotes",
  },
  QUOTE_RESULT_RESTORE: "quote-result-restore",
  QUOTE_WIZARD: "quote-wizard",
  QUOTE_WIZARD_CATG: "quote-wizard-with-category",
  COMPARE_PLANS: "compare-plans",
  COMPARE_PLANS_TRIP: "compare-plans-trip",
  SEARCH: "search",
  ASKEXPERT: "askexpert",
  ASKEXPERTQUESTION: "askexpertquestion",
  ASKEXPERTSEARCH: "askexpertquestionsearch",
  ABOUTUS: "about-us",
  CONTACT: "contact-us",
  REQUEST_QUOTE: "request-quote",
  SUPPORT: "support",
  CLAIMS_HUB: "claims-hub",
  CLAIMS_PROCESS: "claims-process",
  CLAIMS_PROCESS_LEARN_MORE: "claims-process-learn-more",
  WHYVC: "why-visitorscoverage",
  MYPOLICY_LOGIN: "mypolicy-login",
  MYPOLICY_LOGOUT: "mypolicy-logout",
  MYPOLICY_FORGOTPW: "mypolicy-forgotpw",
  MYPOLICY_SETPW: "mypolicy-setpassword",
  MYPOLICY_RESETPW: "mypolicy-resetpassword",
  MYPOLICY_HOME: "mypolicy-home",
  MYPOLICY_POLICIES: "mypolicy-list",
  MYPOLICY_DOCUMENTS: "mypolicy-documents",
  MYPOLICY_CORRECTIONS: "mypolicy-corrections",
  MYPOLICY_CANCELLATION: "mypolicy-cancellation",
  MYPOLICY_RESOLVE_CLAIMS: "mypolicy-resolve-claims",
  MYPOLICY_RENEWAL: "mypolicy-renewal",
  NEWSROOM: "newsroom",
  PARTNER_LANDING: "become-partner",
  PARTNER_LOGIN: "partner-login",
  PARTNER_LOGOUT: "partner-logout",
  PARTNER_VERIFY_EMAIL: "partner-verifyemail",
  PARTNER_CREATE_PASSWORD: "partner-createpassword",
  PARTNER_RESETPW: "partner-resetpassword",
  PARTNER_HOME: "partner-home",
  PARTNER_BANNERS: "partner-banners",
  PARTNER_EARNINGS: "partner-earnings",
  PARTNER_PAYMENT_HISTORY: "partner-payment-history",
  PARTNER_RESOURCES: "partner-resources",
  PARTNER_SETTINGS: "partner-settings",
  PARTNER_HELP: "partner-help",
  PARTNER_CONTACT: "partner-contact",
  PARTNER_COMPLETE_PROFILE: "partner-complete-profile",
  PARTNER_NEW_AGREEMENT: "partner-new-agreement",
  PARTNER_EXTERNAL_PLATFORM: "external-platform",
  PRODUCER_LANDING: "become-producer",
  PRODUCER_API: "producer-api",
  WILDCARD: "wildcard",
  CAREERS: "careers",
  PLAN_CANCELLATION_LANDING: "plan-cancellation-landing",
  PLAN_IDCARD: "plan-id-cards",
  RENEWAL_LANDING: "plan-renewal-landing",
  PROVIDER_LANDING: "plan-provider-landing",
  KNOWLEDGE_CENTER: "knowledge-center",
  CORONAVIRUS_LANDING: "corona-virus-landing",
  PURCHASE_THANKYOU: "purchase-thank-you",
  PURCHASE_TIMED_OUT: "purchase-timed-out",
  PURCHASE_UNAVAILABLE: "purchase-unavailable",
  PlanWorks_LANDING: "plan-works-landing",
  BENEFIT_ESTIMATOR: "benefit-estimator",
  BENEFIT_ESTIMATOR_PAGE_2: "benefit-estimator-step-2",
  FAVORITE_PLANS: "favorite-plans",
  HOW_TRAVEL_INSURANCE_WORKS: "how-travel-ins-works",
  ONE_TREE_PLANTED_LANDING: "one-tree-planted-landing",
  QUOTE_WITH_LUNA: "quote-assistant",
  SWITCH_QUOTE_RESULT: "switch-quote-result",
};

export default RouteNames;
